import type { ScrollViewProps } from "react-native";
import { usePathname } from "expo-router";
import { useTranslation } from "react-i18next";
import { getVisibleSettingsCategories } from "./settings-categories";

const HAS_OWN_HEADING = new Set([
  "/settings",
  "/settings/account",
  "/settings/privacy",
  "/settings/data-management",
  "/settings/agent-access",
  "/settings/feedback",
  "/settings/about",
]);
/** Route pages share one scroller and omit the native transparent-header inset. */
export function SettingsRouteScrollView({ children }: ScrollViewProps) {
  const pathname = usePathname().replace(/\/$/, "");
  const { t } = useTranslation("common");
  const category = getVisibleSettingsCategories().find(
    (item) =>
      pathname === item.nativeRoute ||
      pathname.startsWith(`${item.nativeRoute}/`),
  );
  const labelKey =
    pathname === "/settings/manage-account"
      ? "settings.manageCredentials.title"
      : pathname.startsWith("/settings/connected-apps/")
        ? "settings.connectedApps.detailTitle"
        : category?.labelKey;
  return (
    <div
      style={{
        width: "100%",
        minWidth: 0,
        maxWidth: 760,
        marginInline: "auto",
        padding: "28px clamp(16px, 4vw, 32px) 64px",
        boxSizing: "border-box",
      }}
    >
      {labelKey && !HAS_OWN_HEADING.has(pathname) ? (
        <h1
          style={{
            margin: "0 0 24px",
            fontSize: 26,
            fontWeight: 400,
            lineHeight: "34px",
            color: "var(--text-primary)",
          }}
        >
          {t(labelKey)}
        </h1>
      ) : null}
      {children}
    </div>
  );
}
